// @ts-ignore
import Pagination from "react-js-pagination";
import React from "react";
// @ts-ignore
import t from "../helpers/t";

type Pagin = {
    count: number,
    total_count?: number,
    current_page: number,
    page_count: number,
    has_next_page: boolean,
    has_prev_page: boolean,
    limit: number
};
type MultiSwitchOption = {
    label: any,
    value: any,
    multiEvent: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, value: any) => void
};
type Props = {
    pagination: Pagin,
    itemsCountPerPage: number,
    pageRangeDisplayed: number,
    onChange?: (currentPage: number) => void,
    multiSelect?: boolean,
    multiSwitchOptions?: MultiSwitchOption[],
    selectedItemsCount?: number|null,
    model?: string|null,
    oneItemChecked?: boolean,
    setPaginationLimit?: (limit: number) => void
}
const Paginator = ({
                       pagination,
                       itemsCountPerPage,
                       pageRangeDisplayed,
                       onChange,
                       multiSelect=false,
                       multiSwitchOptions,
                       selectedItemsCount = null,
                       model = null,
                       oneItemChecked = false,
                       setPaginationLimit} : Props) =>{
    const currentPage = (pagination.current_page - 1) * itemsCountPerPage + 1;
    const [localPaginationLimit, setLocalPaginationLimit] = React.useState(itemsCountPerPage);
    let maxPage = (pagination.current_page - 1) * itemsCountPerPage + itemsCountPerPage;
    if(maxPage > pagination.count){
        maxPage = pagination.count;
    }
    const currentPageString = currentPage + ' - ' + maxPage + ' / ' + (typeof pagination.total_count !== 'undefined'?pagination.total_count:pagination.count);
    const directionClass = 'pagin-upper';
   /* const multiSwitchClick = (e, direct) => {
        setMultiSwitch(e,direct)
    }*/
    let timerId:any;
    let limitVar: number;
    const changePaginationLimit = (e: React.ChangeEvent<HTMLInputElement>) => {
        //console.log(e.target.value,'e.target.value')
        setLocalPaginationLimit(Number(e.target.value));
        limitVar = Number(e.target.value);
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            if (typeof setPaginationLimit !== 'undefined') {
               // console.log(limitVar,'limitVar')
                setPaginationLimit(limitVar);
            }
            if (typeof onChange !== 'undefined') {
                onChange(currentPage);
            }
        }, 1000);
    }
    let count = 0;
    let style = {float:"right"};
    let xStyle = {float:"right"};
    return (
        <>

            <div className={"column show-for-large pagin "+directionClass}>
                {multiSelect && typeof multiSwitchOptions !== 'undefined' && <>

                            {multiSwitchOptions.map(option => {
                                count++;
                                return (<>
                                    <div className="" style={{paddingLeft: count===1?"2%":"1%",fontSize: "14px",float:"left"}}>
                                    <span>
                                         <a href="#" onClick={e => option.multiEvent(e,option.value)}>{option.label}</a>
                                    </span>
                                    </div>

                                </>);
                            })}
                            {selectedItemsCount !== null && model !== null && oneItemChecked && <>
                                <div className="" style={{paddingLeft: "1%",fontSize: "14px",float:"left"}}>
                                    <span>
                                         {t('selected')+' '+ model + ': ' + selectedItemsCount}
                                    </span>
                                </div>
                            </>}
                        </>}

                {typeof setPaginationLimit !== 'undefined' && <>
                    <input className="hide-for-small-only" style={{maxWidth:"60px",maxHeight:"24px",float:"right",marginLeft:"20px"}} type="number" onChange={e => changePaginationLimit(e)} value={localPaginationLimit} min={1} max={pagination.count}/>
                </>}
                <span className="ptext" style={{float:"right"}}>{currentPageString}</span>
                <div style={{float:"right"}}>

                    <Pagination
                        activePage={pagination.current_page}
                        itemsCountPerPage={itemsCountPerPage}
                        prevPageText="<"
                        nextPageText=">"
                        totalItemsCount={typeof pagination.total_count !== 'undefined'?pagination.total_count:pagination.count}
                        pageRangeDisplayed={pageRangeDisplayed}
                        onChange={onChange}
                        itemClass="page-item"
                        linkClass="page-link"
                    />
                </div>

            </div>


            <div style={{clear:'both'}}> </div>

        </>
    )
}

export default Paginator;